const CustomCursor = ({ cursorPos, isHoveringLogo }) => (
  <div 
    className={`custom-cursor ${isHoveringLogo ? 'cursor-swirl' : 'cursor-compass'}`}
    style={{ left: cursorPos.x, top: cursorPos.y }}
    data-testid="custom-cursor"
  >
    {isHoveringLogo ? (
      <svg viewBox="0 0 32 32" width="28" height="28">
        <path d="M16,4 C22,4 28,10 28,16 C28,22 22,28 16,28 C11,28 7,24 7,19 C7,14 11,11 15,11 C19,11 21,14 21,17 C21,19 19,21 17,21" fill="none" stroke="#0055cc" strokeWidth="2.5" strokeLinecap="round"/>
      </svg>
    ) : (
      <svg viewBox="0 0 32 32" width="28" height="28">
        <circle cx="16" cy="16" r="13" fill="none" stroke="#1a1a1a" strokeWidth="1"/>
        <polygon points="16,4 14.5,16 17.5,16" fill="#c0392b"/>
        <polygon points="16,28 14.5,16 17.5,16" fill="#2c3e50"/>
        <circle cx="16" cy="16" r="1.5" fill="#1a1a1a"/>
      </svg>
    )}
  </div>
);

export default CustomCursor;
